import { format, utcToZonedTime } from "date-fns-tz";

export const formatDateTime = (dateTime: Date, timeZone: string): string => {
  return format(utcToZonedTime(dateTime, timeZone), "do MMM, hh:mm aa", {
    timeZone,
  });
};
